module.exports = __webpack_public_path__ + "static/media/5-10.644200cb.mp3";